module.exports = __webpack_public_path__ + "static/media/logout.8029bc89.svg";